import { useEffect, useState, useMemo } from "react";
import React from 'react';
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import {Row,Col,Button,} from "reactstrap";
import { default as ReactSelect } from "react-select";
import {getDcForTally} from "../../services/ReportServices";
import {  DatePicker } from 'antd';
import { getAllPlants} from '../../services/PlantServices';
import moment  from 'moment';
import {displayErrorToast,displayError,parseBoolean,parseBooleanToString} from '../../helpers';
import ReportExportDropdown from '../../components/ReportExportDropdown';

const {RangePicker} = DatePicker;
function DcForTally() 
{
    const InitialData = {
        records: []
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(false); 
    const [plants, setPlants] = React.useState([]);
    const [input, setInput] = useState({});
    const [taxlist, setTaxlist] = React.useState([]);

    // Initial state for from_date and to_date
    const initialFromDate = moment().startOf('month');
    const initialToDate =  moment();
    const [fromDate, setFromDate] = useState(initialFromDate);
    const [toDate, setToDate] = useState(initialToDate);
    const handleDateChange = (values) => {
        if ((values) && (values.length === 2)) {
        setFromDate(values[0]);
        setToDate(values[1]);
        }
    };

    React.useEffect(() => {
        //Load data for Plant dropdown
        getAllPlants(cookies)
        .then (
            plantList => {
                const plants = plantList.plant_list.map(
                    plant => {
                        return { value: plant.id, label: plant.plant_alias }
                    }
                );
                setPlants(plants);
            }
        )
    }, []);

    const Home = () => {
        navigate('/Home')
    }

    const columns = useMemo(
        () => {
            const baseColumns =[
            {
                fieldName: "delivery_challan_date",
                headerName: 'Date'
            },
            {
                fieldName: 'delivery_challan_no', 
                headerName: 'Voucher No.'
            },
            {
                fieldName: 'voucher_type', 
                headerName: 'Voucher Type'
            },
            {
                fieldName: 'customer_name', 
                headerName: 'Buyer (Bill to)'
            },
            {
                fieldName: 'customer_address_1', 
                headerName: 'Buyer (Bill to) Address 1'
            },
            {
                fieldName: 'customer_address_2', 
                headerName: 'Buyer (Bill to) Address 2'
            },
            {
                fieldName: 'customer_address_3', 
                headerName: 'Buyer (Bill to) Address 3'
            },
            {
                fieldName: 'customer_pincode', 
                headerName: 'Buyer (Bill to) Pincode'
            },
            {
                fieldName: 'consignee_name', 
                headerName: 'Consignee (Ship to)'
            },
            {
                fieldName: 'consignee_address_1', 
                headerName: 'Consignee (Bill to) Address 1'
            },
            {
                fieldName: 'consignee_address_2', 
                headerName: 'Consignee (Bill to) Address 2'
            },
            {
                fieldName: 'consignee_address_3', 
                headerName: 'Consignee (Bill to) Address 3'
            },
            {
                fieldName: 'consignee_pincode', 
                headerName: 'Consignee (Bill to) Pincode'
            },
            {
                fieldName: "purchase_order_no",
                headerName: 'Voucher Ref. No.'
            },
            {
                fieldName: "customer_gst_no",
                headerName: 'GSTIN/UIN'
            },
            {
                fieldName: "customer_pan_no",
                headerName: 'PAN No.'
            },
            {
                fieldName: "user_remarks",
                headerName: 'Narration'
            },
            {
                fieldName: "sales_order_no",
                headerName: 'Order No'
            },
            {
                fieldName: "sales_order_date",
                headerName: 'Order Date'
            },
            {
                fieldName: 'pay_terms', 
                headerName: 'Terms of Payment'
            },
            {
                fieldName: 'vehicle_no', 
                headerName: 'Vehicle No'
            },
            {
                fieldName: 'delivery_mode', 
                headerName: 'Terms of Delivery'
            },
            {
                fieldName: 'dispatch_through', 
                headerName: 'Dispatch Through'
            },
            {
                fieldName: "project_name",
                headerName: 'Destination'
            },
            {
                fieldName: 'dc_grade', 
                headerName: 'Description of Goods'
            },
            {
                fieldName: 'dc_qty', 
                headerName: 'Quantity'
            },
            {
                fieldName: 'basic_rate', 
                headerName: 'Basic Rate'
            },
            {
                fieldName: 'amount', 
                headerName: 'Amount'
            },
            {
                fieldName: 'gross_total', 
                headerName: 'Gross Total'
            },
            {
                fieldName: 'rounded_off', 
                headerName: 'Rounded Off'
            },
        ];
        console.log(JSON.stringify(data.records)+"data");
        // console.log(JSON.stringify(taxlist)+"taxlist");
        const dynamicColumns = [];
        for (let i = 0; i < taxlist.length; i++) {

            dynamicColumns.push({
                fieldName: taxlist[i].includes(".")?taxlist[i].replace(/[@.]/g, '_'):taxlist[i],
                headerName: taxlist[i]
            });
        }
        console.log(JSON.stringify(dynamicColumns)+"dynamicColumns");
        // Create columns dynamically for tax_list elements
        // const dynamicColumns = data.records.reduce((acc, dc) => {
        // dc.tax_list.forEach(tax => {
        //         if (!acc.some(column => column.fieldName === tax)) {
        //             acc.push({ fieldName: tax, headerName: tax });
        //         }
        //     });
            // return acc;
        // }, []);

        return [...baseColumns, ...dynamicColumns];
    },[data.records]);
   
    const handleCSVExport = (event) => {
        console.log(JSON.stringify(data.records)+'CSV Export');
        exportAsCSV(
            columns
            .map(c => c.headerName),
            data.records.map(dc => {
                const csvRow = {
                    delivery_challan_date: dc.delivery_challan_date,
                    delivery_challan_no: dc.delivery_challan_no,
                    voucher_type:dc.voucher_type,
                    customer_name:dc.customer_name,
                    customer_address_1:dc.customer_address_1,
                    customer_address_2:dc.customer_address_2,
                    customer_address_3:dc.customer_address_3,
                    customer_pincode:dc.customer_pincode,
                    consignee_name:dc.consignee_name,
                    consignee_address_1:dc.consignee_address_1,
                    consignee_address_2:dc.consignee_address_2,
                    consignee_address_3:dc.consignee_address_3,
                    consignee_pincode:dc.consignee_pincode,
                    purchase_order_no:dc.purchase_order_no,
                    customer_gst_no:dc.customer_gst_no,
                    customer_pan_no:dc.customer_pan_no,
                    user_remarks:dc.user_remarks,
                    sales_order_no:dc.sales_order_no,
                    sales_order_date:dc.sales_order_date,
                    pay_terms:dc.pay_terms,
                    vehicle_no: dc.vehicle_no,
                    delivery_mode: dc.delivery_mode,
                    dispatch_through:dc.dispatch_through,
                    project_name:dc.project_name,
                    dc_grade:  dc.dc_grade,
                    dc_qty: dc.dc_qty,
                    basic_rate: dc.basic_rate,
                    amount:  dc.amount,
                    gross_total: dc.gross_total,
                    rounded_off: dc.rounded_off,
                }
          taxlist.forEach(tax => {
            csvRow[tax] = dc[tax] || 0; // If tax key does not exist, default to 0
                    });
                return csvRow;
                }))
    };

    // const handlePDFExport = (event) => {
    //     exportAsPDF(
    //         'Production Report',
    //         columns
    //         .filter(col => ['Date', 'DC Number','Batch Number','Time','Customer Name','Site/Project Name','Production Grade'
    //         ,'Production Qty','Vehicle No','Marketting'].includes(col.headerName))
    //         .map(col=>({header: col.headerName, dataKey: col.fieldName })),
    //         data.records.map(dc => ({
    //             delivery_challan_no: dc.delivery_challan_no,
    //             delivery_challan_date: dc.delivery_challan_date,
    //             delivery_challan_time: dc.delivery_challan_time,
    //             customer_name:dc.customer_name,
    //             project_name:dc.project_name,
    //             salesrep_name: dc.salesrep_name,
    //             vehicle_no: dc.vehicle_no,
    //             production_grade:dc.production_grade,
    //             batch_no: dc.batch_no,
    //             production_qty: dc.production_qty,
    //         })),
    //         'Production_report.pdf'
    //     );
    // };
    
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        // console.log(name+value+"name and value")
        setInput(values => ({...values, [name]: event.target.value}))
    }

    const handleGenerate = () => {
        const inputs = {
            plant_id:input.plant_id,
            from_date:fromDate.format('DD-MM-YYYY'),
            upto_date:toDate.format('DD-MM-YYYY')
          };
        if ((inputs.plant_id) && (inputs.from_date) && (inputs.upto_date))
        {
            setIsLoading(true);
            getDcForTally(cookies, inputs)
            .then(response => {
                const tableData = response.delivery_challan_list
                .map(dc => 
                    {
                        const rowData ={
                    id: dc.id,
                    dispatch_through:'Transit Mixer',
                    delivery_challan_date: dc.delivery_challan_date,
                    delivery_challan_no: dc.delivery_challan_no,
                    customer_name:dc.customer_name,
                    customer_address_1:dc.customer_address_1,
                    customer_address_2:dc.customer_address_2,
                    customer_address_3:dc.customer_address_3,
                    customer_pincode:dc.customer_pincode,
                    consignee_name:dc.consignee_name,
                    consignee_address_1:dc.consignee_address_1,
                    consignee_address_2:dc.consignee_address_2,
                    consignee_address_3:dc.consignee_address_3,
                    consignee_pincode:dc.consignee_pincode,
                    purchase_order_no:dc.purchase_order_no,
                    customer_gst_no:dc.customer_gst_no,
                    customer_pan_no:dc.customer_pan_no,
                    user_remarks:dc.user_remarks,
                    sales_order_no:dc.sales_order_no,
                    sales_order_date:dc.sales_order_date,
                    pay_terms:dc.pay_terms,
                    vehicle_no: dc.vehicle_no,
                    delivery_mode: dc.delivery_mode,
                    project_name:dc.project_name,
                    dc_grade:  dc.dc_grade,
                    dc_qty: dc.dc_qty.toFixed(2),
                    basic_rate: dc.basic_rate.toFixed(2),
                    amount:  dc.amount.toFixed(2),
                    gross_total: dc.gross_total.toFixed(2),
                    rounded_off: dc.rounded_off.toFixed(2),
                    voucher_type:'Delivery Note',
                    // Dynamically add tax properties using bracket notation
        ...response.tax_list.reduce((acc, tax) => {
            console.log(tax+"tax api");
            if(tax.includes(".")){
                console.log("if")
                acc[tax.replace(/[@.]/g, '_')] = (dc[tax] || 0).toFixed(2); // If tax key does not exist, default to 0
            }
            else{
                console.log("else")
                acc[tax] = (dc[tax] || 0).toFixed(2); // If tax key does not exist, default to 0
            }
            acc[tax] = (dc[tax] || 0).toFixed(2); // If tax key does not exist, default to 0
            return acc;
        }, {})
                }
                    // response.tax_list.forEach(tax => {
                    //     rowData[tax] = dc[tax] || 0; // If tax key does not exist, default to 0
                    // });
                    // console.log(JSON.stringify(dc.tax_list)+"dc.taxlist");
                    
                    return rowData;
                });
                setTaxlist(response.tax_list);
                setData({
                    records: tableData
                });
                setIsLoading(false);
            }).catch((error) => {
                console.log(error + "error");
                displayError(error.response?.data);
                setIsLoading(false);
            });
        }
        else
        {
            Swal.fire("plant,from_date,upto_date must not be empty.", "", "info");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleGenerate();
    };

    return (
        <>
            <form className="form" onSubmit={handleSubmit}>
                <div className="container">
                    <Row>
                        <Col xl={12} lg={12} md={12}>
                            <div className="report-legacy-filters form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel ">
                                     
                                <select id="plant_id" name="plant_id"  value={input.plant_id || ""} onChange={handleChange} className="form-control col-sm-4  browser-default custom-select  mandatory-form-control"  required >
                                <option value="">Select plant</option>
                                
                                    {plants.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}</option>
                                    ))}
                                </select>
                                <br/><br/>

                                <div className="report-legacy-filters-row">
                                    <RangePicker
                                        defaultValue={[initialFromDate, initialToDate]}
                                        format="DD-MM-YYYY"
                                        onChange={handleDateChange}
                                        style={{height:"40px",width:"270px"}}
                                    />

                                    <div className="report-legacy-filters-spacer" aria-hidden="true" />

                                    <div className="report-legacy-actions">
                                    <ReportExportDropdown
                                        onCSV={handleCSVExport}
                                        disabled={isLoading}
                                    />
                                    <Button
                                        color="primary"
                                        className="list-page-toolbar-generate-btn"
                                        type="button"
                                        onClick={handleGenerate}
                                        disabled={isLoading}
                                    >
                                        Generate
                                    </Button>
                                    </div>
                                </div>    
                            </div>
                        </Col>
                    </Row> 
                </div>
            </form>
            <div className="container item-list-table-container">
                <div className="table-responsive">
                    <ReactTableWrapper
                        title='DC For Tally'
                        columns={columns}
                        data={data.records}
                        onCSVExport={handleCSVExport}
                        isLoading={isLoading}
                        enableTableSearch={false}
                    />
                </div>
            </div> 
        </>
);
}
export default DcForTally;
